import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS} from "@angular/forms";
import {CustomValidationService} from "../services/custom-validation.service";

@Directive({
  selector: '[app-email]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailPatternDirective, multi: true }]
})
export class EmailPatternDirective {

  constructor(private customValidator: CustomValidationService) { }

  validate(control: AbstractControl): { [key: string]: any } | null {
    return this.customValidator.emailPatternValidator()(control);
  }

}
